import { useNavigate, useLocation } from 'react-router-dom';
import { Users, BookOpen, Bell, LogOut, Settings } from 'lucide-react';
import { clearSession } from '@/lib/api';
import { useI18n } from '@/lib/i18n';

export default function CoachShell({ children, title, back }) {
  const nav = useNavigate();
  const loc = useLocation();
  const { t } = useI18n();
  const isPreviewEnv = (process.env.REACT_APP_BACKEND_URL || '').includes('preview.emergentagent.com');
  const logout = () => { if (window.confirm(t('profile.logoutConfirm'))) { clearSession(); window.location.href = '/'; } };
  const navItems = [
    { to: '/coach/clients', icon: Users, label: t('coach.clients'), active: loc.pathname.startsWith('/coach/client') },
    { to: '/coach/library', icon: BookOpen, label: t('coach.library'), active: loc.pathname === '/coach/library' },
  ];

  return (
    <div className="min-h-screen bg-asgym-bg">
      <header className="sticky top-0 z-40 border-b border-white/[0.06] bg-[#0B0C0E]/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-3.5">
          <button onClick={() => nav('/coach/clients')} data-testid="coach-brand-logo" className="flex items-center gap-2">
            <img src={`${process.env.PUBLIC_URL || ''}/assets/as-gym-logo.png`} alt="A'S GYM" className="h-9 w-auto object-contain mix-blend-screen sm:h-10" />
            <span className="text-[10px] font-bold tracking-[2px] text-asgym-muted">COACH</span>
            {isPreviewEnv && (
              <span data-testid="preview-env-badge" className="rounded-md border border-amber-400/40 bg-amber-400/15 px-1.5 py-0.5 text-[9px] font-extrabold tracking-[1.5px] text-amber-300">PREVIEW</span>
            )}
          </button>
          <div className="flex items-center gap-1">
            {navItems.map((n) => (
              <button key={n.to} onClick={() => nav(n.to)} data-testid={`coachnav-${n.to.split('/').pop()}`}
                className={`flex items-center gap-1.5 rounded-lg px-3 py-2 text-[12px] font-bold tracking-wide transition-colors ${n.active ? 'bg-asgym-accent/15 text-asgym-accent' : 'text-asgym-sub hover:text-white'}`}>
                <n.icon size={15} /> <span className="hidden sm:inline">{n.label}</span>
              </button>
            ))}
            <button onClick={() => nav('/notifications')} className="rounded-lg px-2.5 py-2 text-asgym-sub hover:text-white"><Bell size={16} /></button>
            <button onClick={() => nav('/coach/settings')} data-testid="coachnav-settings" title={t('coach.settings')} aria-label={t('coach.settings')} className={`rounded-lg px-2.5 py-2 ${loc.pathname === '/coach/settings' ? 'text-asgym-accent' : 'text-asgym-sub hover:text-white'}`}><Settings size={16} /></button>
            <button onClick={logout} data-testid="coach-logout" className="rounded-lg px-2.5 py-2 text-asgym-sub hover:text-asgym-error"><LogOut size={16} /></button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-5 py-8">
        {back && (
          <button onClick={() => nav(back)} className="mb-4 text-[12px] font-bold text-asgym-accent" data-testid="coach-back">{t('coach.backToClients')}</button>
        )}
        {title && <h1 className="mb-6 font-display text-3xl font-extrabold tracking-tight text-white">{title}</h1>}
        {children}
      </main>
    </div>
  );
}
